import React, { useCallback } from 'react';
import { Button } from '@glowforge/gf-styled/components';
import { Image } from '@glowforge/gf-styled/components/contentful-views';
import {
  widgetDefaultProps,
  widgetPropType,
} from '@glowforge/gf-styled/models';
/**
 * Find array of strings with a even more specific prefix in Contentful data
 * @param {{ [key: string]: string }} strings
 * @param { string } string
 */
const getRelatedStrings = (strings, string) => Object.keys(strings).filter(
  (key) => key.includes(`signup-modal-${string}`),
);

const Interests = ({
  getString,
  images,
  nextFormStep,
  onSubmit,
  setFormStep,
  strings,
  track,
}) => {
  const interestsLabels = getRelatedStrings(strings, 'interests-label');
  const { brandBgImage } = images;

  /**
   * Background brand styles live here because we get the image from contentful
   */
  const brandStyle = {
    backgroundImage: `url(${brandBgImage ? brandBgImage.fields.file.url : ''})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right bottom',
    backgroundSize: '200px',
  };

  /**
   * Submits interest and contact info
   */
  const onSelectInterest = useCallback((e, interest) => {
    setFormStep(nextFormStep);

    track('madlib_interest_submitted');

    onSubmit(interest);
  }, [setFormStep, nextFormStep, onSubmit]);

  return (
    <div className='interests-step' style={brandStyle}>
      <h1>{getString(strings, 'interests-header')}</h1>
      <div className='interests-grid'>
        {interestsLabels.map((label) => (
          <Button
            key={`${label}-button`}
            onClick={(e) => onSelectInterest(e, strings[label])}>
            {strings[label]}
          </Button>
        ))}
      </div>
      <Button className='not-sure-btn' onClick={onSelectInterest}>
        {getString(strings, 'not-sure-label')}
      </Button>
      <Image
        media={images.bottomInterestsImage}
        className='bottom-interests-image' />
    </div>
  );
};

Interests.propTypes = widgetPropType;
Interests.defaultProps = widgetDefaultProps;

export default Interests;
